import SvgIcon from "@material-ui/core/SvgIcon";
import React from "react";

export default function HomeIcon(props) {
    const defaultProps = {
        color: 'cornflowerblue',
        strokeColor: '#0000007a',
        strokeWidth: 1,
    };

    props = Object.assign(defaultProps, props);

    return (
        <SvgIcon fontSize="large" style={{
            color: props.color
        }}>
            <path
                d="M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z"
                stroke={props.strokeColor}
                strokeWidth={props.strokeWidth}
            />
        </SvgIcon>
    )
}